module.exports = __webpack_public_path__ + "img/01.7b1890ae.jpg";